import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-job',
  imports: [RouterOutlet],
  templateUrl: './job.component.html',
  styleUrl: './job.component.scss'
})
export class JobComponent {
 
}

